<template lang="pug">
.grid-wrapper 
  QuotationData
  OVReceipts
  OVSpareParts
  OVActionHistory
</template>

<script>
import QuotationData from './QuotationData.vue'
import OVReceipts from './OVReceipts.vue'
import OVSpareParts from './OVSpareParts.vue'
import OVActionHistory from './OVActionHistory.vue'

export default {
  name: 'OVDetails',
  components: {
    QuotationData,
    OVReceipts,
    OVSpareParts,
    OVActionHistory
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
.grid-wrapper {
  width: 100%;
  display: grid;

  grid-template-columns: repeat(7, minmax(100px, 240px));
  grid-gap: 14px 40px;

  $split-info-bar-breakpoint: 1449px;

  @media (max-width: $split-info-bar-breakpoint) {
    grid-template-columns: repeat(6, minmax(100px, 240px));
    grid-gap: 14px 32px;
  }

  @include media-breakpoint-down(lg) {
    grid-template-columns: repeat(5, minmax(100px, 240px));
    grid-gap: 14px 32px;
  }

  @include media-breakpoint-down(sm) {
    grid-template-columns: repeat(2, minmax(100px, 300px));
    grid-gap: 14px 168px;
  }

  @include media-breakpoint-down(xs) {
    grid-template-columns: repeat(1, 100%);
    grid-gap: 14px normal;
  }

  &::v-deep {
    hr {
      margin-top: 8px;
      margin-bottom: 2px;
    }
    .span-full,
    .span-full-screen {
      grid-column: 1 / -1;
    }
    .span-2 {
      grid-column: span 2;
    }
  }
}
::v-deep .ot-divider {
  border-top: 1.5px solid #23201C;
}
::v-deep .head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .title {
  color: #23201C;
  font-weight: 700;
  font-size: 1.2em;
}
::v-deep .sub-title {
  color: #23201C;
  font-weight: 700;
  font-size: 1em;
}
::v-deep .input-label {
  color: #525252;
  font-weight: bold;
  font-size: 1em;
}
::v-deep .display-data {
  font-size: 1em;
  color: #525252;
}
::v-deep .details {
  display: flex;
  flex-direction: column;
  width: fit-content;
}
::v-deep  p {
  font-size: 15px;
}
::v-deep .title2 {
  color: #253590;
  font-weight: bold;
  font-style: 15px;
}
</style>